angular.module("digiexam.services", [
	"dx.webapp.answer",
	"dx.webapp.user",
	"dx.webapp.navigation",
	"dx.webapp.rubrics",
	"dx.webapp.angular",
	"digiexam.exam",
	"digiexam.archive",
	"ngCookies",
]);
